import React, { useEffect, useState } from 'react';
import './ScheduleCamp.scss';
import { http, AlertService } from '../fx-core';

export default function ScheduleCamp() {
  const [editCampaign, setEditCampaign] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [campaignProducts, setCampaignProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productsError, setProductsError] = useState(null);
  const [winners, setWinners] = useState({});
  const [winnerStatus, setWinnerStatus] = useState({});
    const [showExpired, setShowExpired] = useState(false);

  const [filters, setFilters] = useState({
    minimumPrice: '',
    maximumPrice: ''
  });
  const [areas, setAreas] = useState([]);
  const [storefronts, setStorefronts] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedStorefront, setSelectedStorefront] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [quantity, setQuantity] = useState('');
  const [price, setPrice] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
 const isCampaignActive = (campaign) => {
    if (!campaign.endDateTime) return false;
    const now = new Date();
    const endDate = new Date(campaign.endDateTime);
    return endDate >= now;
  };

  // Format date
  const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return 'N/A';
  try {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 => 12
    hours = hours.toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  } catch (error) {
    return dateTimeString;
  }
};

  useEffect(() => {
    getCampaign();
  }, []);

  // Fetch all campaigns
  const getCampaign = () => {
    setLoading(true);
    setError(null);
    http.get({ url: "treasurehunt/group", data: {} })
      .then(res => {
        if (res?.data?.success && Array.isArray(res.data.data)) {
          setCampaigns(res.data.data);
        } else {
          setError("Invalid response format");
        }
      })
      .catch(error => {
        setError(error.response?.data?.message || error.message || "Failed to fetch campaigns");
      })
      .finally(() => setLoading(false));
  };

  // Fetch campaign products for editing
  const getCampaignProducts = (campaignGroupId) => {
    if (!campaignGroupId) {
      setProductsError("No campaign ID provided");
      return;
    }
    setProductsLoading(true);
    setProductsError(null);
    http.get({ url: `treasurehunt/group/${campaignGroupId}/products`, data: {} })
      .then(res => {
        if (res?.data?.success && Array.isArray(res.data.data)) {
          setCampaignProducts(res.data.data);
        } else {
          setProductsError("Invalid products response format");
        }
      })
      .catch(error => {
        setProductsError(error.response?.data?.message || error.message || "Failed to fetch products");
      })
      .finally(() => setProductsLoading(false));
  };

  // Delete campaign
  const handleDeleteCampaign = async (campaignGroupId) => {
    if (!campaignGroupId) {
      AlertService.showErrorMsg("No campaign ID provided");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this campaign?")) {
      return;
    }
    try {
      const url = `treasurehunt/group/${campaignGroupId}`;
      const response = await http.delete({ url, data: {} });
      if (response.data?.success) {
        setCampaigns(prev => prev.filter(camp => camp.campaignGroupId !== campaignGroupId));
        AlertService.showSuccessMsg(response.data.message || "Campaign deleted successfully");
      } else {
        throw new Error(response.data?.message || "Failed to delete campaign");
      }
    } catch (error) {
      AlertService.showErrorMsg(
        error.response?.data?.message ||
        error.message ||
        "Failed to delete campaign"
      );
    }
  };

  // Delete Product from campaign
  const handleDeleteProduct = async (productId) => {
    if (!productId) {
      AlertService.showErrorMsg("No product ID provided");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this product?")) {
      return;
    }
    try {
      const response = await http.delete({
        url: `treasurehunt/product/${productId}`,
        data: {}
      });
      if (response.data?.success) {
        setCampaignProducts(prevProducts =>
          prevProducts.filter(product => product.id !== productId)
        );
        AlertService.showSuccessMsg(response.data.message || "Product deleted successfully");
      } else {
        throw new Error(response.data?.message || "Failed to delete product");
      }
    } catch (error) {
      AlertService.showErrorMsg(
        error.response?.data?.message ||
        error.message ||
        "Failed to delete product"
      );
    }
  };

  // Edit campaign mode
  const handleEdit = (campaign) => {
    setSelectedCampaign(campaign);
    setEditCampaign(true);
    getCampaignProducts(campaign.campaignGroupId);
  };

  // Filter change
  const handleFilter = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Fetch products between price range
  const fetchProducts = () => {
    const { minimumPrice, maximumPrice } = filters;
    const min = parseFloat(minimumPrice);
    const max = parseFloat(maximumPrice);
    if (isNaN(min) || isNaN(max)) {
      AlertService.showErrorMsg("Please enter valid price range");
      return;
    }
    http.post({
      url: "treasurehunt/filtered",
      data: { minPrice: min, maxPrice: max }
    }).then(res => {
      const communities = Array.isArray(res.data) ? res.data : [];
      setAreas(communities.map(community => ({
        id: community.communityId,
        name: community.communityName,
        stores: community.storefronts?.map(store => ({
          id: store.stallId,
          name: store.stallName,
          items: store.products || []
        })) || []
      })));
      setStorefronts([]);
      setProductItems([]);
      setSelectedArea('');
      setSelectedStorefront('');
      setSelectedProduct('');
      setQuantity('');
      setPrice('');
    }).catch(error => {
      AlertService.showErrorMsg(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch filtered products"
      );
    });
  };

  // When area is selected
  useEffect(() => {
    if (selectedArea) {
      const area = areas.find(a => String(a.id) === String(selectedArea));
      if (area) {
        setStorefronts(area.stores || []);
        setProductItems([]);
        setSelectedStorefront('');
        setSelectedProduct('');
        setQuantity('');
        setPrice('');
      }
    }
  }, [selectedArea, areas]);

  // When storefront is selected
  useEffect(() => {
    if (selectedStorefront) {
      const store = storefronts.find(s => String(s.id) === String(selectedStorefront));
      if (store) {
        setProductItems(store.items || []);
        setSelectedProduct('');
        setQuantity('');
        setPrice('');
      }
    }
  }, [selectedStorefront, storefronts]);

  // When product is selected, set both quantity and price
  useEffect(() => {
    if (selectedProduct && productItems.length > 0) {
      const product = productItems.find(p =>
        String(p.itemId) === String(selectedProduct)
      );
      if (product) {
        setQuantity(product.quantity ?? '');
        setPrice(product.price ?? '');
      } else {
        setQuantity('');
        setPrice('');
      }
    }
  }, [selectedProduct, productItems]);

  // Add product to campaign
  const addProduct = async () => {
    if (!selectedCampaign || !selectedCampaign.campaignGroupId) {
      AlertService.showErrorMsg("No campaign selected");
      return;
    }
    if (!selectedArea || !selectedStorefront || !selectedProduct || !quantity || !price) {
      AlertService.showErrorMsg("Please fill all fields");
      return;
    }
    const product = productItems.find(p =>
      String(p.itemId) === String(selectedProduct)
    );
    if (!product) {
      AlertService.showErrorMsg("Selected product not found");
      return;
    }
    setIsSubmitting(true);
    try {
      const payload = {
        campaignGroupId: selectedCampaign.campaignGroupId,
        campaignName: selectedCampaign.campaignName,
        startDate: selectedCampaign.startDateTime,
        endDate: selectedCampaign.endDateTime,
        item: {
          communityId: parseInt(selectedArea),
          communityName: areas.find(a => String(a.id) === String(selectedArea))?.name || '',
          stallId: parseInt(selectedStorefront),
          stallName: storefronts.find(s => String(s.id) === String(selectedStorefront))?.name || '',
          itemId: parseInt(selectedProduct),
          itemName: product.itemName || '',
          quantity: parseInt(quantity),
          price: parseFloat(price)
        }
      };
      const response = await http.post({
        url: 'treasurehunt/add-product-update-group',
        data: payload
      });
      if (response.data?.success) {
        AlertService.showSuccessMsg("Product added to campaign successfully");
        getCampaignProducts(selectedCampaign.campaignGroupId);

        // Reset form fields
        setSelectedProduct('');
        setQuantity('');
        setPrice('');
      } else {
        throw new Error(response.data?.message || "Failed to add product");
      }
    } catch (error) {
      AlertService.showErrorMsg(
        error.response?.data?.message ||
        error.message ||
        "Failed to add product to campaign"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Submit campaign updates (name/date changes)
const submitCampaignUpdates = async () => {
  if (!selectedCampaign || !selectedCampaign.campaignGroupId) {
    AlertService.showErrorMsg("No campaign selected");
    return;
  }
  
  setIsSubmitting(true);
  try {
    const payload = {
      campaignGroupId: selectedCampaign.campaignGroupId,
      campaignName: selectedCampaign.campaignName,
      startDate: selectedCampaign.startDateTime,
      endDate: selectedCampaign.endDateTime,
      item: null // Explicitly set to null if no product is being added
    };
    
    const response = await http.post({
      url: 'treasurehunt/add-product-update-group',
      data: payload
    });
    
    if (response.data?.success) {
      AlertService.showSuccessMsg("Campaign updated successfully");
      getCampaign(); // Refresh the campaign list
      setEditCampaign(false); // Close the edit mode
    } else {
      throw new Error(response.data?.message || "Failed to update campaign");
    }
  } catch (error) {
    AlertService.showErrorMsg(
      error.response?.data?.message ||
      error.message ||
      "Failed to update campaign"
    );
  } finally {
    setIsSubmitting(false);
  }
};
  // Fetch "found" status for campaign products
// Improved winner fetching logic
// Updated winner fetching logic
// Simplified winner fetch without date comparisons


// Table rendering remains the same:

// In your table rendering:

  // Filter campaigns based on active status and showExpired toggle
  const filteredCampaigns = showExpired 
    ? campaigns 
    : campaigns.filter(isCampaignActive);useEffect(() => {
  if (editCampaign && selectedCampaign && campaignProducts.length > 0) {
    campaignProducts.forEach((product) => {
      if (!product?.itemId) return;

      http.get({
        url: `treasurehunt/winners/${product.itemId}`,
        data: {},
      })
      .then((res) => {
        const result = res.data;
        const itemId = product.itemId.toString();
        
        // Initialize defaults
        let status = "Not Found";
        let winnerName = "TBD";

        if (result.success && Array.isArray(result.winners) && result.winners.length > 0) {
          // Get the last winner
          const lastWinner = result.winners[result.winners.length - 1];
          status = "Found";
          winnerName = lastWinner.userName || 
                      lastWinner.firstname || 
                      lastWinner.email || 
                      `User ${lastWinner.userId}`;

          // Automatically save the last winner to the campaign
          saveWinnerToCampaign(result.treasureHuntCampaignId, lastWinner.userId, winnerName);
        }

        // Update state
        setWinnerStatus(prev => ({ ...prev, [itemId]: status }));
        setWinners(prev => ({ ...prev, [itemId]: winnerName }));
      })
      .catch(() => {
        const itemId = product.itemId.toString();
        setWinnerStatus(prev => ({ ...prev, [itemId]: "Error" }));
        setWinners(prev => ({ ...prev, [itemId]: "TBD" }));
      });
    });
  }
}, [editCampaign, selectedCampaign, campaignProducts]);

// Function to save winner to campaign
const saveWinnerToCampaign = (campaignId, userId, userName) => {
  http.post({
    url: 'treasurehunt/save-winner',
    data: {
      campaignId,
      userId,
      userName
    }
  })
  .then((response) => {
    console.log('Winner saved successfully:', response.data);
  })
  .catch((error) => {
    console.error('Error saving winner:', error);
  });
};


  return (
    <div>
      {loading && <div className="loading">Loading campaigns...</div>}
      {error && <div className="error">Error: {error}</div>}
    {/* <div className="campaign-filter-toggle">
        <label>
          <input 
            type="checkbox" 
            checked={showExpired} 
            onChange={() => setShowExpired(!showExpired)} 
          />
          Show expired campaigns
        </label>
      </div> */}

        <table className="campaign-table">
        <thead>
          <tr>
            <th>Campaign Name</th>
            <th>Start</th>
            <th>End</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredCampaigns.length > 0 ? (
            filteredCampaigns.map((camp) => (
              <tr 
                key={camp.campaignGroupId} 
                className={!isCampaignActive(camp) ? 'expired' : ''}
              >
                <td>{camp.campaignName || "Unnamed Campaign"}</td>
                <td>{formatDateTime(camp.startDateTime)}</td>
                <td>{formatDateTime(camp.endDateTime)}</td>
                <td>
                  <button
                    className="edit-btn"
                    onClick={() => handleEdit(camp)}
                  >
                    ✏️
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => handleDeleteCampaign(camp.campaignGroupId)}
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))
          ) : (
            !loading && (
              <tr>
                <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                  {showExpired ? "No campaigns found" : "No active campaigns found"}
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>

      {editCampaign && selectedCampaign && (
        <div className="new-camp-container">
          <div className="filters">
            <div className="filter-group">
              <select>
                <option value="">Selection Criteria</option>
                <option value="price">Price</option>
              </select>
            </div>
            <div className="filter-group">
              <input
                type="number"
                name="minimumPrice"
                placeholder="Min"
                value={filters.minimumPrice}
                onChange={handleFilter}
              />
            </div>
            <div className="filter-group">
              <input
                type="number"
                name="maximumPrice"
                placeholder="Max"
                value={filters.maximumPrice}
                onChange={handleFilter}
              />
            </div>
            <button className="fetch-btn" onClick={fetchProducts}>
              Fetch
            </button>
          </div>

          {productsLoading && <div className="loading">Loading products...</div>}
          {productsError && <div className="error">Error: {productsError}</div>}

          {/* Dropdowns */}
          <div className="dropdowns">
            <select
              value={selectedArea}
              onChange={(e) => setSelectedArea(e.target.value)}
            >
              <option value="">Area</option>
              {areas.map((area) => (
                <option key={area.id} value={area.id}>
                  {area.name}
                </option>
              ))}
            </select>

            <select
              value={selectedStorefront}
              onChange={(e) => setSelectedStorefront(e.target.value)}
              disabled={!selectedArea}
            >
              <option value="">Storefront</option>
              {storefronts.map((store) => (
                <option key={store.id} value={store.id}>
                  {store.name}
                </option>
              ))}
            </select>

            <select
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e.target.value)}
              disabled={!selectedStorefront}
            >
              <option value="">Product</option>
              {productItems.map((product) => (
                <option key={product.itemId} value={product.itemId}>
                  {product.itemName}
                </option>
              ))}
            </select>

            <div className="filter-group">
              <input
                type="number"
                placeholder="Quantity"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                min="1"
              />
            </div>

            <div className="filter-group">
              <input
                type="number"
                placeholder="Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                min="0"
                step="0.01"
              />
            </div>

            <button
              className="add-btn"
              onClick={addProduct}
              disabled={isSubmitting || !selectedProduct}
            >
              {isSubmitting ? "Adding..." : "+ Add"}
            </button>
          </div>

          <table className="campaign-table">
            <thead>
              <tr>
                <th>Area</th>
                <th>Storefront</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Status</th>
                <th>Action</th>
                <th>Winner</th>
              </tr>
            </thead>
            <tbody>
              {campaignProducts.length > 0 ? (
                campaignProducts.map((product) => (
                  <tr key={product.id || product.itemId}>
                    <td>{product.communityName || "N/A"}</td>
                    <td>{product.stallName || "N/A"}</td>
                    <td>{product.itemName || "N/A"}</td>
                    <td>{product.quantity ?? "1"}</td>
                    <td>
                      {product.price != null
                        ? product.price
                        : "N/A"}
                    </td>
                    <td>{winnerStatus[product.itemId.toString()] || "Checking..."}</td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() =>
                          handleDeleteProduct(product.id)
                        }
                      >
                        🗑️
                      </button>
                    </td>
                   <td>{winners[product.itemId.toString()] || "TBD"}</td>
                  </tr>
                ))
              ) : (
                !productsLoading && (
                  <tr>
                    <td
                      colSpan="8"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                      }}
                    >
                      No products found. Add products using the form above.
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
<div className="campaign-footer">
  <input
    type="text"
    value={selectedCampaign.campaignName}
    onChange={(e) =>
      setSelectedCampaign({
        ...selectedCampaign,
        campaignName: e.target.value
      })
    }
    placeholder="Campaign Name"
  />
  <input
    type="datetime-local"
    value={selectedCampaign.startDateTime ? selectedCampaign.startDateTime.split('.')[0] : ''}
    onChange={(e) =>
      setSelectedCampaign({
        ...selectedCampaign,
        startDateTime: e.target.value
      })
    }
  />
  <input
    type="datetime-local"
    value={selectedCampaign.endDateTime ? selectedCampaign.endDateTime.split('.')[0] : ''}
    onChange={(e) =>
      setSelectedCampaign({
        ...selectedCampaign,
        endDateTime: e.target.value
      })
    }
  />

    <button
    className="submit-btn"
    onClick={submitCampaignUpdates}
    disabled={isSubmitting}
  >
    {isSubmitting ? "Submitting..." : "Submit"}
  </button>
  <button
    className="submit-btn"
    onClick={()=>setEditCampaign(false)}
    // disabled={isSubmitting}
  >
   Cancel
  </button>
</div>
          {/* <div className="campaign-footer">
            <input
              type="string"
              value={selectedCampaign.campaignName}
              readOnly
              onChange={(e) =>
                setSelectedCampaign({
                  ...selectedCampaign,
                  campaignName: e.target.value,
                  
                })
              }
              placeholder="Campaign Name"
            />
            <input
              type="text"
              value={formatDateTime(selectedCampaign.startDateTime)}
              readOnly
            />
            <input
              type="text"
              value={formatDateTime(selectedCampaign.endDateTime)}
              readOnly
            />
            <button
              className="submit-btn"
              onClick={()=> setEditCampaign(false)}
              disabled={isSubmitting}
            >
                Submit
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div> */}
        </div>
      )}
    </div>
  );
}
